import { MessageCircle, Instagram, Check } from "lucide-react";
import { Reveal } from "./Reveal";
import { waLink, INSTAGRAM_URL, IMAGES, WHATSAPP_NUMBER_DISPLAY } from "./constants";

const POINTS = [
  "Message me directly on WhatsApp — no call centres",
  "You'll deal with me from first chat to moving day",
  "Evenings and weekends? No problem",
  "Whole-of-market, independent and fully qualified",
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="py-24 lg:py-32 bg-[#052B38]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-16 items-center">
        <Reveal>
          <div className="relative max-w-md mx-auto lg:mx-0">
            <div className="absolute -inset-3 rounded-[2.2rem] border border-amber-400/30 translate-x-4 translate-y-4" />
            <div className="relative rounded-[2rem] overflow-hidden border border-white/10">
              <img
                src={IMAGES.advisor}
                alt="Kieran Woolley, independent mortgage advisor at KW Mortgages"
                className="w-full aspect-[4/5] object-cover"
                data-testid="advisor-portrait"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#04222C]/85 via-transparent to-transparent" />
              <div className="absolute bottom-5 left-5 right-5 rounded-2xl border border-white/10 bg-[#03222D]/70 backdrop-blur-xl px-5 py-4">
                <p className="font-display font-semibold text-white">Kieran Woolley</p>
                <p className="font-mono text-[11px] tracking-[0.2em] uppercase text-amber-400/90 mt-1">
                  Independent Mortgage Advisor
                </p>
              </div>
            </div>
          </div>
        </Reveal>

        <div>
          <Reveal>
            <p className="font-mono text-xs tracking-[0.3em] uppercase text-amber-400/90 mb-5">
              Nice to Meet You
            </p>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-white leading-tight">
              Advice from a person, not a portal.
            </h2>
            <p className="mt-6 text-base sm:text-lg text-slate-400 leading-relaxed">
              I started KW Mortgages because getting a mortgage should feel like
              asking a knowledgeable friend — not sitting in a bank being sold
              to. Straight answers, honest advice, and someone in your corner
              until the keys are in your hand.
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <ul className="mt-8 space-y-4">
              {POINTS.map((p) => (
                <li key={p} className="flex items-start gap-3 text-sm sm:text-base text-slate-300">
                  <span className="mt-0.5 h-5 w-5 shrink-0 rounded-full bg-amber-400/15 border border-amber-400/40 flex items-center justify-center">
                    <Check size={12} className="text-amber-400" />
                  </span>
                  {p}
                </li>
              ))}
            </ul>
          </Reveal>
          <Reveal delay={0.18}>
            <div className="mt-9 flex flex-wrap gap-4">
              <a
                href={waLink("Hi Kieran, I'd like to introduce myself and talk mortgages.")}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="about-whatsapp-button"
                className="inline-flex items-center gap-2.5 rounded-full bg-[#25D366] px-7 py-3.5 text-sm font-semibold text-[#03222D] transition-colors duration-300 hover:bg-[#2be072]"
              >
                <MessageCircle size={17} />
                {WHATSAPP_NUMBER_DISPLAY}
              </a>
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="about-instagram-button"
                className="inline-flex items-center gap-2.5 rounded-full border border-white/20 bg-white/5 px-7 py-3.5 text-sm font-semibold text-white transition-colors duration-300 hover:border-amber-400/50 hover:text-amber-300"
              >
                <Instagram size={17} />
                @kieranwoolleymortgages
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
